import { render, staticRenderFns } from "./filmTab.vue?vue&type=template&id=2b5a2342&scoped=true"
import script from "./filmTab.vue?vue&type=script&lang=js"
export * from "./filmTab.vue?vue&type=script&lang=js"
import style0 from "./filmTab.vue?vue&type=style&index=0&id=2b5a2342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a2342",
  null
  
)

export default component.exports